import { eventGroupsAdapterSelectors } from '../redux/slices/eventGroups';
import { createSelector } from 'reselect';
import { defaultResourceSelector } from './defaultSelectorUtils';

const getCurrentWorkspaceEventGroupFromStore = (state) =>
  state.currentWorkspace.eventGroups;

export const getEventGroupById = (id) => (state) =>
  eventGroupsAdapterSelectors.selectById(state, id);

export const currentWorkspaceEventGroup = createSelector(
  getCurrentWorkspaceEventGroupFromStore,
  (state) => (id) => eventGroupsAdapterSelectors.selectById(state, id),
  (eventGroupIds, getEventGroupById) =>
    eventGroupIds.map((eventGroupId) =>
      defaultResourceSelector({
        main: {
          resourceId: eventGroupId,
          getResourceById: getEventGroupById,
        },
      })
    )
);
